import * as t from 'io-ts';

/*
 * Runtime types.
 */

export const enum StashSourcesEnum {
  SERVER = 'S',
  CLIENT = 'C',
}

export const RStashVersion = t.type({
  [StashSourcesEnum.SERVER]: t.number,
  [StashSourcesEnum.CLIENT]: t.number,
});

/*
 * Types.
 */

/** Version vector that describes which updates have been seen from each source. */
export type StashVersion = {
  readonly [O in StashSourcesEnum]: number;
};

/*
 * Constants.
 */

export const zeroStashVersion: StashVersion = Object.freeze({
  [StashSourcesEnum.SERVER]: 0,
  [StashSourcesEnum.CLIENT]: 0,
});

/*
 * Helpers.
 */

export function checkStashVersionIncludesVersion(version: StashVersion, otherVersion: StashVersion): boolean {
  return [StashSourcesEnum.SERVER, StashSourcesEnum.CLIENT].every(
    (source) => version[source] >= otherVersion[source],
  );
}

export function mergeStashVersions(left: StashVersion, right: StashVersion): StashVersion {
  return {
    [StashSourcesEnum.SERVER]: Math.max(left[StashSourcesEnum.SERVER], right[StashSourcesEnum.SERVER]),
    [StashSourcesEnum.CLIENT]: Math.max(left[StashSourcesEnum.CLIENT], right[StashSourcesEnum.CLIENT]),
  };
}

export function incrementStashVersionClient(version: StashVersion): StashVersion {
  return {
    ...version,
    [StashSourcesEnum.CLIENT]: version[StashSourcesEnum.CLIENT] + 1,
  };
}
